module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-25.17107ab1.jpg";